import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

export class ModuleRecordCountDto {
  subject!: AppSubjectEnum;
  count!: number;
}
